export default import.meta.ROLLDOWN_FILE_URL_1G5ETLhC$bx4zEx8uXqaGw